import FormattedText from './FormattedText';
import WindowForm from './WindowForm';

import { can } from '../../../permissions';

import ConfirmButton from './ConfirmButton';
import PortalButton from './PortalButton';
import React, { useState } from 'react';
import moment from 'moment';
import { MdEdit, MdDelete, MdAdd } from 'react-icons/md';
import { usePortalMutation, usePortal } from '../hooks';
import { ErrorNotice, Empty } from './Feedback';

export default function WindowManager({ selection }) {
  const { user } = usePortal();
  const allowed = can(user, 'portal_configuracoes', 'edit');
  const [editing, setEditing] = useState(null),
    [adding, setAdding] = useState(false),
    remove = usePortalMutation((d) => `selecoes/${selection.id}/prazos/${d.id}`, 'DELETE');
  return (
    <section className="card module-card module-content">
      <div className="card-body">
        <div className="portal-admin-row">
          <h2 className="module-details-title">Prazos para recursos</h2>
          <PortalButton
            className="btn btn-success hidethis"
            disabled={!allowed}
            onClick={() => {
              setAdding(true);
              setEditing(null);
            }}
            type="button"
          >
            <MdAdd />
            Adicionar prazo
          </PortalButton>
        </div>
        <p>Recursos de questões respeitam também o período configurado no processo da OnTest.</p>
        <ErrorNotice error={remove.error} />
        {selection.appeal_windows.length === 0 && <Empty>Nenhum registro encontrado.</Empty>}
        {selection.appeal_windows.map((w) => (
          <div className="portal-admin-item" key={w.id}>
            <span>
              <FormattedText>{w.title}</FormattedText>
              <small className="d-block">
                {moment(w.starts_at).format('DD/MM/YYYY HH:mm')} até{' '}
                {moment(w.ends_at).format('DD/MM/YYYY HH:mm')}
              </small>
            </span>
            <div className="portal-admin-actions hidethis actions-group">
              <PortalButton
                title="Editar prazo"
                disabled={!allowed}
                className="btn btn-sm btn-primary"
                onClick={() => {
                  setEditing(w);
                  setAdding(false);
                }}
                type="button"
              >
                <MdEdit />
              </PortalButton>
              <ConfirmButton
                title="Excluir prazo"
                className="btn btn-sm btn-danger"
                disabled={!remove.allowed}
                type="button"
                message={'Excluir este prazo?'}
                onConfirm={() =>
                  remove.mutate({
                    id: w.id,
                  })
                }
              >
                <MdDelete />
              </ConfirmButton>
            </div>
          </div>
        ))}
        {(adding || editing) && (
          <WindowForm
            key={editing?.id || 'new'}
            selection={selection}
            item={editing}
            onDone={() => {
              setAdding(false);
              setEditing(null);
            }}
          />
        )}
      </div>
    </section>
  );
}
